import React from 'react'
import styled from 'styled-components';
import Img from '../../assets/Images/AboutMision.png'
const P = styled.p`
color: #202939;
margin-bottom: 0px;
font-size: 46px;
font-weight: 700;
@media (max-width: 992px){
    font-size: 30px;
    margin: 10px 0;
}
.color-para{
    color: #3545EE;
    }
    `
const Button = styled.button`
border-radius: 20px;
border: none;
background: none;
color: #3545EE;
font-size: 15px;
font-weight: 600;
`
const Para = styled.p`
font-size: 17px;
`
function Mission() {
  return (
    <div className='container bg-white'>
        <div className='row m-0 pt-5 pb-2 d-flex flex-wrap justify-content-center align-items-center'>
            <div className='col-md-6'>
                <Button>
                    Mission
                </Button>
                <P>
                    <span className='d-lg-block color-para'>Safe and Fast </span> 
                    <span className='d-lg-block'> cryptocurrency trading</span>
                </P>
            </div>
            <div className='col-md-6'>
                <Para className='text-justify'>Our platform is designed to empower users with seamless access to crypto trading, asset safekeeping, and lightning-fast international transfers. Backed by a passionate team of early adopters, we are committed to building a future where cryptocurrencies are not just an alternative but a standard used by everyone.</Para>
            </div>
        </div>
        <div className='d-none d-md-block mt-5 text-center'>
            <img src={Img} width={'100%'}/>
        </div>
    </div>
  )
}

export default Mission